import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextInput,
} from "app/common/renderInput";
import {
  getRequisitionBankList,
  addRedHandler,
} from "app/services/requisitionService";

const requisitionSchema = Yup.object().shape({
  amount: Yup.number()
    .required("Please enter Amount")
    .min(1, "Amount should be greater than 0"),
  bankId: Yup.string().required("Please enter Payment Through"),
  transferMethod: Yup.string().required("Please select Payment Type"),
  referenceNo: Yup.string()
    .min(6, "Reference must be at least 6 characters")
    .required("Please enter Referance Number"),
  transactionDetails: Yup.string().optional(),
  requestDate: Yup.string().required("Please enter Request Date"),
});

const AddReq = () => {
  const [requestDate, setRequestDate] = useState("");
  const [amount, setAmount] = useState("");
  const [bankId, setBankId] = useState("");
  const [transactionDetails, setTransactionDetails] = useState("");
  const [transferMethod, setTransferMethod] = useState("NEFT");
  const [bankCharges, setBankCharges] = useState(0);
  const [referenceNo, setReferenceNo] = useState("");
  const [bankList, setBankList] = useState([]);
  const [paymentTypeList] = useState([
    { value: "NEFT", label: "NEFT" },
    { value: "UPI", label: "UPI" },
    { value: "RTGS", label: "RTGS" },
    { value: "ONLINE", label: "ONLINE" },
  ]);

  const loadBankLists = async () => {
    const response = await getRequisitionBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName + " - " + x.accountNumber,
      };
    });
    setBankList(bankList);
  };

  useEffect(() => {
    loadBankLists();
  }, []);

  const requisitionHandler = async (values, { resetForm }) => {
    const res = await addRedHandler(values);
    if (res) {
      NotificationManager.success("Requisition send successfully");
    } else {
      NotificationManager.error("Requisition Failed");
    }

    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));
    resetForm({ values: "" });
  };

  const handlChangeDate = (date) => {
    setRequestDate(moment(date).format("DD-MM-YYYY"));
  };

  return (
    <div>
      <Helmet>
        <title>Add Requisition</title>
      </Helmet>
      <div>
        <Card>
          <Card.Body>
            <Formik
              initialValues={{
                requestDate,
                amount,
                bankId,
                transactionDetails,
                transferMethod,
                bankCharges,
                referenceNo,
              }}
              validationSchema={requisitionSchema}
              onSubmit={requisitionHandler}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit}>
                  {/* <div>
                    <div className="col-md-12">
                      {Object.values(errors).map(msg => (
                        <>
                          {msg}
                          <br />
                        </>
                      ))}
                    </div>
                  </div> */}

                  <Row className="mb-3 mt-3">
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="amount"
                        display="Amount"
                        placeholder="Amount"
                        value={values.amount}
                        error={errors.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.amount}
                        required
                      ></RenderTextInput>
                    </Col>
                    <Col>
                      <RenderSelectInput
                        name="bankId"
                        display="Payment Through"
                        placeholder="Payment Through"
                        value={values.bankId}
                        error={errors.bankId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.bankId}
                        items={bankList}
                        required
                      ></RenderSelectInput>
                    </Col>
                    <Col>
                      <RenderSelectInput
                        name="transferMethod"
                        display="Payment Type"
                        placeholder="Payment Through"
                        value={values.transferMethod}
                        error={errors.transferMethod}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transferMethod}
                        items={paymentTypeList}
                        required
                      ></RenderSelectInput>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="referenceNo"
                        display="Reference No"
                        placeholder="Reference No"
                        value={values.referenceNo}
                        error={errors.referenceNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.referenceNo}
                        required
                      ></RenderTextInput>
                    </Col>
                    <Col>
                      <RenderDateInput
                        type="date"
                        name="requestDate"
                        display="Request Date"
                        onBlur={handleBlur}
                        value={values.requestDate}
                        onChange={handleChange}
                        touched={touched.requestDate}
                        error={errors.requestDate}
                        required
                      ></RenderDateInput>
                    </Col>

                    <Col>
                      <RenderTextInput
                        type="text"
                        name="transactionDetails"
                        display="Remarks (if any)"
                        placeholder="transactionDetails"
                        value={values.transactionDetails}
                        error={errors.transactionDetails}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transactionDetails}
                        required
                      ></RenderTextInput>
                    </Col>
                  </Row>

                  <Row>
                    <Col className="mt-2">
                      <button type="submit" className="btn btn-primary">
                        Submit Requisition
                      </button>
                    </Col>
                  </Row>
                </form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default AddReq;
